<template>
  <div class="editor-options-setting-dialog" :class="isBigScreen ? 'bc-setting' : ''">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
        <!--        <el-collapse-item-->
        <!--            @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')"-->
        <!--            title="数据设置"-->
        <!--            name="7"-->
        <!--        >-->
        <!--          <div-->
        <!--              class="setting-item clearFloat"-->
        <!--              v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '7')"-->
        <!--          >-->
        <!--            <div v-html="content" style="display:none"></div>-->
        <!--            <iframe  id="noteEditor" src="noteEditorPage.html"  height="300" frameborder="0"></iframe>-->
        <!--            <el-button class="mt16" size="small" type="primary" @click="getNoteEditorContent">保存数据</el-button>-->
        <!--          </div>-->
        <!--        </el-collapse-item>-->
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')" title="外观" name="2">
          <div class="content" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')">
            <div class="verticallyCenter">
              <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
            </div>
            <widthAndSizeAndZindex
              :options="options"
              :ids="ids"
              showSetItem="rotate"
              class="mt16"
              v-if="request_prefix !== 'bigScreen'"
            />
            <cx-background :background.sync="background" imgType="10" class="mt16" />
            <div class="content-item mt16">
              <div class="checkbox_colorPicker_container">
                <!-- <el-checkbox @change="checkboxHandle(3)">阴影</el-checkbox> -->
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              />
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')" title="边框" name="4">
          <div class="content" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')">
            <div class="content-item mb16">
              <border-radius
                :borderTypeFlag.sync="borderTypeFlag"
                :borderRadius.sync="borderRadius"
                :borderTopLeftRadius.sync="borderTopLeftRadius"
                :borderTopRightRadius.sync="borderTopRightRadius"
                :borderBottomRightRadius.sync="borderBottomRightRadius"
                :borderBottomLeftRadius.sync="borderBottomLeftRadius"
                :sliderMax="paddingMax"
              />
            </div>
            <div>
              <div class="mb16">边框</div>
              <cx-border
                :borderWidth.sync="borderWidth"
                :borderStyle.sync="borderStyle"
                :borderColor.sync="borderColor"
                :borderIsThemeColor.sync="borderIsThemeColor"
              />
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')" title="边距" name="5">
          <cx-padding
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')"
            :paddingTypeFlag.sync="textPaddingTypeFlag"
            :padding.sync="padding"
            :paddingTop.sync="paddingTop"
            :paddingRight.sync="paddingRight"
            :paddingBottom.sync="paddingBottom"
            :paddingLeft.sync="paddingLeft"
          />
        </el-collapse-item>
        <el-collapse-item
          v-if="request_prefix === 'bigScreen'"
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
          title="动画设置"
          name="6"
        >
          <big-screen-animate-set></big-screen-animate-set>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  name: "noteEditor-options-setting",
  components: { widthAndSizeAndZindex, controlWidthAndSizeAndZindex },
  props: { options: Object },
  data() {
    return {
      activeNames: ["1", "2", "7", "8"],
      collapseActiveNames: ["1", "2", "7", "8"],
      allCollapseNames: ["3", "4", "5"],
      hoverOpt: [],
      this1: this,
      activeType: 1,
      sliderMax: 360,
      paddingMax: 200,
      contentType: 1, // 本地数据
      iframeSrc: "/noteEditorPage.html"
    }
  },
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
    this.$nextTick(() => {
      this.initNoteEditor(this.content)
    })
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    isBigScreen() {
      if (this.request_prefix == "bigScreen") {
        return true
      } else {
        return false
      }
    },
    content: {
      get() {
        let content = this.options.content
        let arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", qquot: '"', quot: '"' }
        content = content.replace(/&(lt|gt|nbsp|amp|qqout|quot);/gi, function (all, t) {
          return arrEntities[t]
        })
        return content
      },
      set(newVal) {
        let val = newVal.replace(/[<>&" ]/g, function (c) {
          return { "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&qquot;", " ": "&nbsp;" }[c]
        })
        this.$changeOptionsEV(val, "content", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    opacity: {
      get() {
        // return this.options.opacity || 100
        return this.checkAndSetPrimaryVal(this.options, "opacity", "opacity", 100)
      },
      set(newVal) {
        newVal !== this.opacity && this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowColor", "boxShadowColor", ["rgba(255,255,255,1)"])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowH", "boxShadowH", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowV", "boxShadowV", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowBlur", "boxShadowBlur", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowSpread", "boxShadowSpread", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    activeRect() {
      // this.options();
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    // rotate: {
    //   get() {
    //     return parseInt(this.options.rotate)
    //   },
    //   set(newVal) {
    //     this.$changeOptionsEV(newVal + "deg", "rotate", false)
    //   }
    // },
    // 边距
    textPaddingTypeFlag: {
      get() {
        let defaultType = 2
        return this.checkAndSetPrimaryVal(this.options, "textPaddingTypeFlag", "textPaddingTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textPaddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        // return this.options.padding || 0
        return this.checkAndSetPrimaryVal(this.options, "padding", "padding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingTop", "paddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        // return this.options.paddingRight || 0
        return this.checkAndSetPrimaryVal(this.options, "paddingRight", "paddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        // return this.options.paddingLeft || 0
        return this.checkAndSetPrimaryVal(this.options, "paddingLeft", "paddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        // return this.options.paddingBottom || 0
        return this.checkAndSetPrimaryVal(this.options, "paddingBottom", "paddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderRadius", "borderRadius", this.borderTopLeftRadius)
      },
      set(newVal) {
        if (this.borderTypeFlag === 2) {
          this.$changeOptionsEV(
            [newVal, newVal, newVal, newVal, newVal],
            [
              "borderTopLeftRadius",
              "borderTopRightRadius",
              "borderBottomLeftRadius",
              "borderBottomRightRadius",
              "borderRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "borderRadius", false)
        }
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderTopLeftRadius", "borderTopLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderTopRightRadius", "borderTopRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderBottomRightRadius", "borderBottomRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderBottomLeftRadius", "borderBottomLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    // 描边
    borderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderWidth", "borderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderColor", "borderColor", "rgba(255,255,255,0)")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    borderStyle: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderStyle", "borderStyle", "solid")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderIsThemeColor", "borderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    }
  },
  methods: {
    initNoteEditor(val) {
      if (!document.getElementById("noteEditor")) {
        return
      }
      let iframeWin = document.getElementById("noteEditor").contentWindow
      let richContent = iframeWin.RichTextUitl //执行iframe页的方法
      if (iframeWin && !richContent) {
        setTimeout(() => {
          this.initNoteEditor(val)
        }, 100)
      }
      if (!richContent) {
        return
      }
      let content = val
      if (this.contentType == 1) {
        // 处理添加附件之后，附件的路径重复问题
        content = !val ? " " : val
        if (content.indexOf("https://noteyd.chaoxing.com/attachment/insert") > 1) {
          content = content.replace(/https:\/\/noteyd\.chaoxing\.com\/attachment\/insert/g, "insert")
          content = content.replace(/https:\/\/noteyd\.chaoxing\.com\/attachment\/\/insert/g, "insert")
        }
      }
      this.reInitUEditor(iframeWin, richContent, content)
    },
    reInitUEditor(iframeWin, richContent, content) {
      if (iframeWin.UE && iframeWin.UE.getEditor) {
        richContent.initUEditor(100, content, "")
      } else {
        setTimeout(() => {
          this.reInitUEditor(iframeWin, richContent, content)
        }, 100)
      }
    },
    getNoteEditorContent() {
      let iframeWin = document.getElementById("noteEditor").contentWindow
      let richContent = iframeWin.RichTextUitl //执行iframe页的方法
      this.content = richContent.getRichText().rtf_content
    },
    switchHandle(type) {
      this.activeType = type
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH) || !Array.isArray(this.boxShadowColor)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    }
  }
})
</script>

<style scoped lang="scss">
::v-deep .tox-tinymce {
  z-index: 9999;
  display: flex !important;
}
p {
  margin-bottom: 0;
}
.color-picker-container.custom-text-bg {
  // width: calc(100% - 40px);
  // display: inline-block;
  // vertical-align: middle;
}
.paddingl0 {
  padding-left: 0;
}

::v-deep .boxshadow-wrap {
  z-index: 1002;
}
::v-deep .boxshadow-wrap .ml24 {
  margin-left: 2px;
  margin-right: 10px;
}
::v-deep.font-arrangement-btn {
  background: #f0f0f0;
}
.bc-setting ::v-deep.font-arrangement-btn {
  padding: 3px;
  border: none;
}
.lightColor444 {
  color: rgba(0, 0, 0, 0.4);
}
.deepColor444 {
  color: rgba(255, 255, 255, 0.4);
}
</style>
